export const validators = {
	data() {
		return {
			validators: {
				category: {
					required: true,
				},
				subcategory: {
					required: true,
				},
				subsubcategory: {
					required: false,
				},
				mxik: {
					required: false,
				},
				unit: {
					required: true
				},
				name: {
					required: true
				},
				shortName: {
					required: true,
				},
				sku: {
					required: true,
				},
				barcode: {
					required: true,
				},
			}
		}
	},

	methods: {
		checkField(name) {
			const valid = Object.keys(this.validationFields).some(() =>  this.validationFields[name].valid );
			const invalid = Object.keys(this.validationFields).some(() =>  this.validationFields[name].invalid );
			const touched = Object.keys(this.validationFields).some(() =>  this.validationFields[name].touched );
			const changed = Object.keys(this.validationFields).some(() =>  this.validationFields[name].changed );
			if (( touched) && valid) {
				return true;
			}
			if ((touched) && !valid) {
				return false
			}
			if ((changed) && invalid) {
				return false
			}

			return null
		}
	}
};
